module.exports = __webpack_public_path__ + "static/media/sound.d3b3ccc5.mp3";